export default "__VITE_ASSET__ba5a2a80__"